export default "__VITE_ASSET__b7e74fe9__"